import React, { useRef, useCallback } from 'react';
import CtaLink from 'components/essentials/Cta/CtaLink';
import IconShare from 'components/icons/iconShare';
import CtaButton from 'components/essentials/Cta/CtaButton';
import useStaticFavoritesProductData from 'hooks/useStaticFavoritesProductData';
import ProductCardGridUI from 'components/consumer/ProductCardGridUI';
import ProductCardStatic from 'components/consumer/ProductCardStatic';
import { colorWhite } from 'styles/layout/colors';

const FavoritesList = () => {
  const wishlistStaticData = useStaticFavoritesProductData();
  const { products: fetchedProducts, loading } = wishlistStaticData;
  
  const productsRef = useRef([]);
  const initialLoadingRef = useRef(true);

  // Only update values when not loading
  productsRef.current = !loading ? fetchedProducts : productsRef.current;
  initialLoadingRef.current = !loading ? false : initialLoadingRef.current;

  const products = productsRef.current;
  const initialLoading = initialLoadingRef.current;
  
  const shareByEmail = useCallback(() => {
    const listOfProducts = products.reduce(
      (content, item) =>
        `${content}${item.name ?? ''}%0D%0ALink: https://www.joybird.com${
          item.path
        }%0D%0A%0D%0A`,
      ''
    );
    const emailContent = `mailto:?subject=Discover my Joybird wishlist&body=Dear,%0D%0AI'd like to share my Joybird wishlist with you. I thought you might be interested in the following products.%0D%0A%0D%0A${listOfProducts}`;
    window.location.href = emailContent;
  }, [products]);

  return (
    <>
      <div className="px-[3.333vw] py-4 [border-bottom:1px_solid_#d7d7d7] lg:px-[3.333vw] lg:py-6">
        <h1 className="text-gray text-xl font-bold">Wishlist</h1>
      </div>
      
      <div className="mt-0 mx-[3.333vw] mb-8 max-[786px]:m-0 lg:mb-12 [&_img]:lg:max-w-full [&_img]:lg:h-auto">

        <div className="flex content-between items-center px-0 py-4 text-gray lg:px-0 lg:py-8">
          {loading && (
            <div className="text-lg font-bold flex-[1_1] pl-[5px] border-1 border-red">
              Loading favorites....
            </div>
          )}
          {!loading && !initialLoading && products.length ? (
            <div className="text-lg font-bold flex-[1_1] pl-[5px] border-1 border-yellow-dark">
              {products.length} Items
            </div>
          ) : null}
          {!initialLoading && products.length ? (
            <div className="flex-[1_1] text-right">
              <CtaButton
                size="sm"
                onClick={shareByEmail}
                color="brand"
                styling="solid-button"
              >
                <IconShare color={colorWhite} /> Share via Email
              </CtaButton>
            </div>
          ) : null}
        </div>
        
        {!initialLoading && products.length ? (
          <ProductCardGridUI columnsOnDesktop="4" limitWidth>
            {products.map(product => (
              <ProductCardStatic
                key={product.slug}
                {...product}
              />
            ))}
          </ProductCardGridUI>
        ) : null}

        {!loading && !initialLoading && !products.length && (
          <section className="w-full [display:inherit]">
            <section className="[&_h2]:text-2xl [&_h2]:font-bold [&_h2]:mx-0 [&_h2]:my-10 px-0 py-[85px] max-w-[1040px] mx-auto my-0 text-center [&_img]:block [&_img]:mt-0 [&_img]:mx-auto [&_img]:mb-[70px]">
              <h2>Your wishlist is empty.</h2>
              <CtaLink
                to="/shop/"
                styling="solid-button"
                size="sm"
                color="brand"
              >
                <span>Shop Now</span>
              </CtaLink>
            </section>
          </section>
        )}
        
      </div>
    </>
  );
};

export default FavoritesList;